import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-choice-prod-price-grps',
  templateUrl: './choice-prod-price-grps.component.html',
  styleUrls: ['./choice-prod-price-grps.component.css']
})
export class ChoiceProdPriceGrpsComponent implements OnInit {
    public prodId: string;

    public itemsListPriceGroups: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.prodId = this.stateService.getStateParams()['prod_id'];
    }

    private async loadPriceGroups() {
        if (!!this.prodId) {
            this.itemsListPriceGroups = await this.datatask.Post(1200, { prod_id: this.prodId });
        }
    }

    private async init() {
        this.loadPriceGroups();
    }

    ngOnInit() {
        this.init();
    }
}
